module.exports = __webpack_public_path__ + "img/29_42.53d98440.png";